export const GetExternalDocumentPacketDocumentation = `
# Get External Document Packet

Retrieve the entire external document packet record (i.e. fax image) from the
Notable data store for the flow's starting entity or the specified ID for
tests.
`;
